import React from 'react';
import { NextPage, GetStaticProps } from 'next';
import { Col, Row } from '@sumup-oss/circuit-ui/legacy';

import TopicName from 'components/TopicName';
import TypedSections from 'components/TypedSections';
import { TypeContainer } from 'components/styledComponents';
import { Props } from 'types/index';
import { getIndexStaticProps } from 'services/staticGeneration/index';

const Page: NextPage<Props> = ({ sectionTree, articles, sectionTypeTree }) => {
  return (
    <Col span="12" skip="0">
      {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        Object.keys(sectionTypeTree).map((topic) => (
          <Row key={topic}>
            {TopicName(topic)}
            <TypeContainer>
              <TypedSections
                sectionTree={sectionTree}
                articles={articles}
                topic={topic}
                sectionTypeTree={sectionTypeTree}
              />
            </TypeContainer>
          </Row>
        ))
      }
    </Col>
  );
};

export const getStaticProps: GetStaticProps = getIndexStaticProps;

export default Page;
